import { render } from "./tagEdit copy.vue?vue&type=template&id=c5cb908a&scoped=true"
import script from "./tagEdit copy.vue?vue&type=script&lang=js"
export * from "./tagEdit copy.vue?vue&type=script&lang=js"

import "./tagEdit copy.vue?vue&type=style&index=0&id=c5cb908a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5cb908a"],['__file',"src/views/active/components/tagEdit copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5cb908a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5cb908a', __exports__)) {
    console.log('reload')
    api.reload('c5cb908a', __exports__)
  }
  
  module.hot.accept("./tagEdit copy.vue?vue&type=template&id=c5cb908a&scoped=true", () => {
    console.log('re-render')
    api.rerender('c5cb908a', render)
  })

}


export default __exports__